import { Empty, Input, Popconfirm } from "antd";
import React, { useCallback, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useGlobalFilter, useSortBy, useTable } from "react-table";
import { toast, ToastContainer } from "react-toastify";
import { deleteInvoice } from "../../../lib/deleteInvoice";
import ModalEditEstadoPago from "./ModalEditEstadoPago";

// Filtro global para la tabla de facturas
const GlobalFilter = ({ globalFilter, setGlobalFilter }) => {
  return (
    <Input
      placeholder="Buscar Facturas..."
      value={globalFilter || ""}
      onChange={(e) => setGlobalFilter(e.target.value || undefined)}
      style={{ marginBottom: "0px", width: "50%", minWidth: "250px" }}
    />
  );
};

const AllInvoicesTable = ({ data }) => {
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showEditPagoModal, setShowEditPagoModal] = useState();
  const [visibleRows, setVisibleRows] = useState(25);

  // Cargar más filas al hacer scroll
  const loadMoreRows = useCallback(() => {
    setVisibleRows((prev) => prev + 25);
  }, []);

  // Host del servidor para los links de comprobantes
  const serverHost = `http://${window.location.hostname.includes('localhost') ? 'localhost:4000' : 'unioninformatica.org:4000'}`;

  // Definición de columnas de la tabla
  const columns = useMemo(
    () => [
      { Header: "Factura Nº", accessor: "invoiceNumber" },
      { Header: "Empresa", accessor: "company.name" },
      {
        Header: "Estado",
        accessor: "status",
        Cell: (props) => {
          const status = props?.row?.values?.status;
          const labelStyle = {
            padding: "5px 10px",
            borderRadius: "5px",
            color: "white",
            display: "inline-block",
          };
          
          switch (status) {
            case "ACCEPTED":
              return (
                <span style={{ ...labelStyle, backgroundColor: "green" }}>
                  ACEPTADO
                </span>
              );
            case "PENDING":
              return (
                <span style={{ ...labelStyle, backgroundColor: "orange" }}>
                  PENDIENTE
                </span>
              );
            case "CANCELED":
              return (
                <span style={{ ...labelStyle, backgroundColor: "red" }}>
                  CANCELADO
                </span>
              );
            default:
              return <span style={labelStyle}>{status}</span>;
          }
        },
      },
      {
        Header: "Estado Pago",
        accessor: "estadoPago",
        Cell: (props) => {
          const estadoPago = props?.row?.values?.estadoPago
          const labelStyle = {
            padding: "5px 10px",
            borderRadius: "5px",
            display: "inline-block",
          };
          
          switch (estadoPago) {
            case "PAGADO":
              return (
                <span style={{ ...labelStyle, border:"1px solid green", color:"green" }}>
                  Pagado <i className="fas fa-check"></i>
                </span>
              );
            case "PENDING":
              return (
                <span style={{ ...labelStyle, border:"1px solid orange", color:"orange"}}>
                  PENDIENTE
                </span>
              );
            default:
               return (
                <span style={{ ...labelStyle, border:"1px solid orange", color:"orange"}}>
                    PENDIENTE
                </span>
              );;
          }
          // Si el estado de pago está vacío o indefinido
          
          // if (
          //   !props?.row?.values?.estadoPago ||
          //   props?.row?.values?.estadoPago === ""
          // ) {
          //   if (props?.row?.values?.status === "ACCEPTED") {
          //     return <p>Pagado</p>;
          //   } else {
          //     return <p>Pendiente</p>;
          //   }
          // }
          // return <p>{props.row.values.estadoPago}</p>;
        },
      },
      {
        Header: "Tipo Aporte",
        accessor: "tipoFactura",
        Cell: (props) => {
          const tipoFactura = props?.row?.values?.tipoFactura;
          // Si tipo_factura es nulo, indefinido o vacío
          if (!tipoFactura || tipoFactura === "") {
            return <span>sindical</span>;
          }
          return <span>{tipoFactura}</span>;
        },
      },
      {
        Header: " ",
        disableSortBy: false,
        Cell: (props) => (
          <div className="d-flex justify-content-end">
            {/* Botón para editar estado de pago */}
            <Link
              to={"#"}
              onClick={() => {
                setSelectedInvoice(props?.row?.original);
                setShowEditPagoModal(true);
              }}
              className="btn btn-primary shadow btn-xs sharp me-3"
            >
              <i className="fas fa-money-check-alt"></i>
            </Link>
            {/* Botón para ver comprobante si existe */}
            {props?.row?.original.comprobantePath && (
              <Link
                to={`${serverHost}${props?.row?.original?.comprobantePath ?? ""}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success shadow btn-xs sharp me-3"
                title="Ver comprobante"
              >
                <i className="fas fa-paperclip"></i>
              </Link>
            )}
            {/* Botón para eliminar factura */}
            <Popconfirm
              placement="left"
              title={"Atención"}
              description={
                <h6>
                  ¿Desea <strong>eliminar</strong> esta factura?
                </h6>
              }
              onConfirm={async () => {
                await handleDeleteInvoice(props?.row?.original);
              }}
              okText="Si"
              cancelText="No"
            >
              <Link
                to={"#"}
                className="btn btn-danger shadow btn-xs sharp me-3"
              >
                <i className="fas fa-trash"></i>
              </Link>
            </Popconfirm>
          </div>
        ),
      },
    ],
    [serverHost]
  );

  // Instancia de la tabla
  const tableInstance = useTable(
    { columns, data, initialState: { pageSize: 25 } },
    useGlobalFilter,
    useSortBy
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    preGlobalFilteredRows,
  } = tableInstance;

  const { globalFilter } = state;

  // Filas visibles según el scroll
  const filteredRows = useMemo(
    () => rows.slice(0, visibleRows),
    [rows, visibleRows]
  );

  // Manejar scroll para cargar más filas
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - scrollTop < clientHeight + 10) {
      loadMoreRows();
    }
  };

  // Eliminar factura
  const handleDeleteInvoice = async (factura) => {
    debugger
    try {
      // eslint-disable-next-line no-debugger
      debugger;
      const response = await deleteInvoice(factura);
      
      if (response.status === 200) {
        toast.success("Factura eliminada correctamente", {
          position: "bottom-left",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      toast.error("Hubo un error al eliminar ! ", {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
      });
      console.error("Error al eliminar la factura", error);
    }
  };

  return (
    <>
      {data.length === 0 ? (
        <Empty
          style={{ marginTop: "10%" }}
          description="No hay empleados cargados."
        />
      ) : (
        <div
          className="card-body"
          onScroll={handleScroll}
          style={{ height: "700px", overflowY: "auto", padding: "0px" }}
        >
          <div className="dataTables_wrapper">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "#fff",
                padding: "10px",
              }}
            >
              <GlobalFilter
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
              />
            </div>

            <table
              {...getTableProps()}
              className="table dataTable display"
            >
              <thead
                style={{
                  position: "sticky",
                  top: "50px",
                  backgroundColor: "#fff",
                  zIndex: 1,
                }}
              >
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        {column.canSort && (
                          <span className="ml-1">
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <i className="fa fa-arrow-down ms-2 fs-14" />
                              ) : (
                                <i className="fa fa-arrow-up ms-2 fs-14" />
                              )
                            ) : (
                              <i className="fa fa-sort ms-2 fs-14" />
                            )}
                          </span>
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {filteredRows.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => (
                        <td {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <ModalEditEstadoPago
        show={showEditPagoModal}
        setShow={setShowEditPagoModal}
        selectedInvoice={selectedInvoice}
      />
      <ToastContainer />
    </>
  );
};

export default AllInvoicesTable;
